import { createStyles } from '@material-ui/core/styles';

const styles = (theme: any) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    margin: '0'
  },
  heading: {
    padding: '10px',
    backgroundColor: '#eeeeee',
    borderBottom: '1px solid #ddd',
    fontSize: '14px',
    fontWeight: 'bold',
    lineHeight: '34px',
    textTransform: 'uppercase'
  },
  hyperlink: {
    color: theme.palette?.hyperLink,
    textDecoration: 'underline',
  },
  dataGrid: {
    'flex': 1,
    '& .dx-datagrid-rowsview': {
      border: 'none'
    },
    '& .dx-datagrid-headers': {
      borderTop: '1px solid #ddd'
    }
  }
});

export default styles;
